export default (params) => ({
  trigger: {
    name: 'content_blocks.product_row.show_items',
    params: params,
  },
  config: {
    schema: {
      item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      sub_feature: {
        enum: [
          'personalized_assortment',
          'recently_viewed',
          'bestsellers',
          'featured_items',
          'related_products',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'show_items',
    },
    nonInt: true,
  },
});
